var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShaggy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_308",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29240",
    "data-name": "Group 29240",
    transform: "translate(138 10837)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28370",
    "data-name": "Group 28370",
    transform: "translate(-129 -10831)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Ellipse_308)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_308-2",
    "data-name": "Ellipse 308",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "url(#radial-gradient)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_50296",
    "data-name": "Path 50296",
    d: "M21.716,40,21,45.724h4.293l.716-5.009Z",
    transform: "translate(-124.937 -10832.052)",
    fill: "#efad60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50297",
    "data-name": "Path 50297",
    d: "M17.578,17.448S14,17.448,14,22.457c0,1.431.716,4.293,3.578,3.578.716,5.009,2.929,8.744,8.586,7.871,4.636-.716,5.231-3.811,4.978-6.059-.274-2.436-1.438-11.852.031-16.838C32.452,6.668,24.733,6,24.733,6l-6.44,6.44Z",
    transform: "translate(-122.946 -10822.38)",
    fill: "#ffcc80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50298",
    "data-name": "Path 50298",
    d: "M12.44,7.871S6.716,6.44,6,19.319c1.431-2.147,2.147-2.147,2.147-2.147S6.361,27.746,16.912,29.222a13.389,13.389,0,0,1-1.131-5.481s-3.342.587-3.342-3.706a7.4,7.4,0,0,1,.716-2.862s.716,3.578,2.862,5.009c2.147-3.578.716-10.733.716-10.733s5.724-1.431,7.155-3.578c0,2.862-.716,3.578-.716,3.578A12.553,12.553,0,0,0,28.8,9.53c-1.332,2.634-.617,10.5-.617,10.5S32.474,15.026,30.328,9.3C36.052,5.009,28.181,0,23.888,0S12.44,2.862,12.44,7.871Z",
    transform: "translate(-120.67 -10820.673)",
    fill: "#a07416"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50299",
    "data-name": "Path 50299",
    d: "M23.117,29.973s1.61,2.295,3.768,1.85a9.99,9.99,0,0,1,4.076-.171c.753.137,1.062-.171,1.507-.891.565,1.353-1.028,2.089-1.576,2.055a15.246,15.246,0,0,0-3.871.582A3.33,3.33,0,0,1,23.117,29.973Z",
    transform: "translate(-125.539 -10829.199)",
    fill: "#efad60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50300",
    "data-name": "Path 50300",
    d: "M26.521,24.548c.374.914,1.332,2.2,3.92,2.04a2.319,2.319,0,0,0,1.956-3.2c-.547-1.072-2.147-2.055-2.215-3.357a4.514,4.514,0,0,1,.377-2.021A4.037,4.037,0,0,0,29.5,20.369c-.034,1.3,1.252,2.453,1.53,3.266C31.644,25.439,28.493,25.918,26.521,24.548Z",
    transform: "translate(-126.508 -10825.795)",
    fill: "#efad60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50301",
    "data-name": "Path 50301",
    d: "M27.317,15.549c-.514-.719-2.946-1.918-4.008,1.918C24.679,15.686,26.049,15.378,27.317,15.549Z",
    transform: "translate(-125.594 -10824.88)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50302",
    "data-name": "Path 50302",
    d: "M34.843,17.162a1.933,1.933,0,0,0-2.295-.411C33.4,15.141,34.775,15.655,34.843,17.162Z",
    transform: "translate(-128.222 -10825.157)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_481",
    "data-name": "Ellipse 481",
    cx: 0.716,
    cy: 0.716,
    r: 0.716,
    transform: "translate(-100.36 -10806.362)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_482",
    "data-name": "Ellipse 482",
    cx: 0.716,
    cy: 0.716,
    r: 0.716,
    transform: "translate(-95.351 -10806.362)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShaggy);
export default __webpack_public_path__ + "static/media/shaggy.795e55b31e0e9135b666f5430958ccdf.svg";
export { ForwardRef as ReactComponent };